// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\"><circle cx=\"4\" cy=\"4\" r=\"3\" fill=\"%236C63FF\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   VARIABLES
══════════════════════════════════════════════════════════ */
:root {
  --primary: #6C63FF;
  --primary-dark: #5548E0;
  --bg: #FAFBFC;
  --surface: #FFFFFF;
  --border: #E1E4E8;
  --text: #1A1D23;
  --text-muted: #6A737D;
  --text-light: #959DA5;
  --success: #22C55E;
  --warning: #F59E0B;
  --error: #EF4444;
  --radius: 8px;
  --shadow: 0 1px 3px rgba(0,0,0,0.08);
  --shadow-lg: 0 10px 40px rgba(0,0,0,0.12);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  background: var(--bg);
  color: var(--text);
  line-height: 1.6;
}

.app {
  min-height: 100vh;
}

/* ══════════════════════════════════════════════════════════
   LOADING & UNAUTHORIZED
══════════════════════════════════════════════════════════ */
.loading,
.unauthorized {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 20px;
  padding: 20px;
  text-align: center;
}

.unauthorized h1 {
  font-size: 2rem;
  color: var(--text);
}

.unauthorized p {
  color: var(--text-muted);
}

/* ══════════════════════════════════════════════════════════
   BUTTONS
══════════════════════════════════════════════════════════ */
.btn-primary,
.btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.btn-primary {
  background: var(--primary);
  color: white;
}

.btn-primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108,99,255,0.3);
}

.btn-ghost {
  background: transparent;
  color: var(--text);
  border: 1px solid var(--border);
}

.btn-ghost:hover {
  background: var(--bg);
  border-color: var(--primary);
}

/* ══════════════════════════════════════════════════════════
   DASHBOARD
══════════════════════════════════════════════════════════ */
.dashboard {
  max-width: 1600px;
  margin: 0 auto;
  padding: 40px 3%;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 20px;
}

.dashboard-header h1 {
  font-size: 2rem;
  color: var(--text);
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.search-input {
  padding: 10px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 14px;
  min-width: 250px;
  background: var(--surface);
  transition: border 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary);
}

/* ══════════════════════════════════════════════════════════
   KANBAN
══════════════════════════════════════════════════════════ */
.kanban {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

.kanban-column {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  min-height: 400px;
}

.column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--border);
}

.column-header h2 {
  font-size: 1.1rem;
  font-weight: 600;
}

.count {
  background: var(--bg);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-muted);
}

.column-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.empty-column {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-light);
  font-size: 0.9rem;
}

/* ══════════════════════════════════════════════════════════
   CARD
══════════════════════════════════════════════════════════ */
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.card:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.card-icon {
  font-size: 1.5rem;
  line-height: 1;
}

.card h3 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-badge {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 8px;
  display: inline-block;
}

.badge-warning {
  background: #FEF3C7;
  color: #92400E;
}

.card-meta {
  color: var(--text-light);
  font-size: 0.8rem;
  margin-bottom: 12px;
}

.card-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.card-action-btn {
  padding: 6px 12px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--surface);
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s;
}

.card-action-btn:hover {
  background: var(--bg);
  border-color: var(--primary);
}

.card-action-btn.delete:hover {
  background: #FEE2E2;
  border-color: var(--error);
  color: var(--error);
}

/* ══════════════════════════════════════════════════════════
   EDITOR
══════════════════════════════════════════════════════════ */
.editor {
  min-height: 100vh;
  background: var(--bg);
}

.editor-topbar {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 8px 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: var(--shadow);
}

.editor-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.save-status {
  margin-left: auto;
  margin-right: 16px;
  color: var(--text-light);
  font-size: 0.8rem;
}

.save-status-dirty {
  color: var(--warning);
}

.color-picker {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--text-muted);
}

.color-picker input[type="color"] {
  width: 40px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
}

.editor-content {
  max-width: 960px;
  margin: 0 auto;
  /* Reserva espacio bajo el último bloque para poder escribir con el cursor
     en una zona cómoda de la pantalla, no pegado al borde inferior. */
  padding: 22px 48px max(320px, 42vh);
}

.page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.icon-input {
  font-size: 2.25rem;
  width: 58px;
  text-align: center;
  border: none;
  background: transparent;
  cursor: pointer;
}

.icon-input:focus {
  outline: 2px solid var(--primary);
  border-radius: var(--radius);
}

.title-input {
  flex: 1 1;
  font-size: 2.15rem;
  font-weight: 700;
  border: none;
  background: transparent;
  color: var(--text);
  padding: 4px 0;
}

.title-input:focus {
  outline: none;
}

.title-input::placeholder {
  color: var(--text-light);
}

/* ══════════════════════════════════════════════════════════
   BLOCK TOOLBAR
══════════════════════════════════════════════════════════ */
.block-toolbar {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 8px;
  flex-wrap: wrap;
  position: sticky;
  top: 55px;
  z-index: 90;
  box-shadow: var(--shadow);
}

.toolbar-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-right: 8px;
  white-space: nowrap;
}

.tool-btn {
  min-width: 32px;
  height: 30px;
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--surface);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.toolbar-slash-hint {
  margin-left: auto;
  color: var(--text-light);
  font-size: 0.78rem;
  white-space: nowrap;
}

kbd {
  display: inline-block;
  min-width: 20px;
  padding: 1px 5px;
  border: 1px solid var(--border);
  border-bottom-width: 2px;
  border-radius: 4px;
  background: var(--surface);
  color: var(--text-muted);
  font-family: inherit;
  font-size: 0.75rem;
  line-height: 1.35;
  text-align: center;
}

.keyboard-hint {
  margin: 0 4px 8px;
  color: var(--text-light);
  font-size: 0.78rem;
}

.tool-btn:hover {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

/* ══════════════════════════════════════════════════════════
   BLOCKS
══════════════════════════════════════════════════════════ */
.blocks {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.block {
  display: flex;
  position: relative;
  gap: 6px;
  min-height: 30px;
  padding: 2px 6px;
  border-left: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.2s;
  cursor: text;
}

.block:hover {
  background: rgba(108,99,255,0.02);
  border-left-color: var(--primary);
}

.block.block-active {
  background: rgba(108,99,255,0.05);
  border-left-color: var(--primary);
  border-left-width: 2px;
}

.block-controls {
  display: flex;
  position: absolute;
  right: calc(100% + 5px);
  top: 2px;
  flex-direction: column;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 5;
}

.block:hover .block-controls,
.block:focus-within .block-controls {
  opacity: 1;
}

.block-btn {
  width: 24px;
  height: 22px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--surface);
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-btn:hover {
  background: var(--bg);
  border-color: var(--primary);
}

.block-btn.delete:hover {
  background: #FEE2E2;
  border-color: var(--error);
}

.block-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.block-content {
  flex: 1 1;
  min-width: 0;
  position: relative;
}

/* ══════════════════════════════════════════════════════════
   BLOCK INPUTS
══════════════════════════════════════════════════════════ */
.input-h1,
.input-h2,
.input-h3,
.input-text,
.input-callout,
.input-bullet,
.input-numbered,
.input-todo {
  width: 100%;
  border: none;
  background: transparent;
  font-family: inherit;
  color: var(--text);
  padding: 2px 0;
  resize: none;
  overflow: hidden;
  min-height: 1.45em;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.input-h1 {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.25;
}

.input-h2 {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.3;
}

.input-h3 {
  font-size: 1.12rem;
  font-weight: 600;
  line-height: 1.35;
}

.input-text {
  font-size: 1rem;
  line-height: 1.5;
}

.input-callout {
  font-size: 1rem;
  background: #F0F0FF;
  padding: 8px 10px;
  border-left: 4px solid var(--primary);
  border-radius: 4px;
}

.input-bullet {
  font-size: 1rem;
  padding-left: 21px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 3px 0.62em;
}

.input-numbered {
  flex: 1 1;
  font-size: 1rem;
  min-width: 0;
}

.numbered-block {
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.numbered-marker {
  min-width: 24px;
  padding-top: 2px;
  color: var(--primary-dark);
  font-weight: 600;
  line-height: 1.5;
  text-align: right;
}

.input-h1:focus,
.input-h2:focus,
.input-h3:focus,
.input-text:focus,
.input-callout:focus,
.input-bullet:focus,
.input-numbered:focus,
.input-todo:focus {
  outline: none;
}

.input-h1::placeholder,
.input-h2::placeholder,
.input-h3::placeholder,
.input-text::placeholder,
.input-callout::placeholder,
.input-bullet::placeholder,
.input-numbered::placeholder,
.input-todo::placeholder {
  color: var(--text-light);
}

.todo-block {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.todo-block input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-top: 4px;
}

.divider {
  border: none;
  border-top: 2px solid var(--border);
  margin: 9px 0;
}

/* Menú de comandos con / */
.slash-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 200;
  width: min(340px, calc(100vw - 40px));
  max-height: 360px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  box-shadow: var(--shadow-lg);
}

.slash-menu-title {
  padding: 5px 8px 7px;
  color: var(--text-light);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.slash-command {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.slash-command:hover,
.slash-command-selected {
  background: rgba(108, 99, 255, 0.09);
}

.slash-command-icon {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  font-size: 0.86rem;
  font-weight: 700;
}

.slash-command strong,
.slash-command small {
  display: block;
}

.slash-command strong {
  font-size: 0.88rem;
}

.slash-command small {
  margin-top: 1px;
  color: var(--text-muted);
  font-size: 0.74rem;
}

.slash-empty {
  padding: 14px 10px;
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* Confirmación de eliminación de bloques */
.delete-confirmation-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(26, 29, 35, 0.42);
  backdrop-filter: blur(2px);
}

.delete-confirmation-dialog {
  width: min(430px, 100%);
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.delete-confirmation-icon {
  display: grid;
  width: 40px;
  height: 40px;
  margin: 0 auto 12px;
  place-items: center;
  border-radius: 50%;
  background: #FEE2E2;
  color: var(--error);
  font-size: 1.25rem;
  font-weight: 800;
}

.delete-confirmation-dialog h2 {
  margin-bottom: 8px;
  font-size: 1.2rem;
}

.delete-confirmation-dialog p {
  color: var(--text-muted);
  font-size: 0.92rem;
  line-height: 1.5;
}

.delete-confirmation-dialog blockquote {
  max-height: 84px;
  margin: 14px 0 0;
  overflow: hidden;
  padding: 10px 12px;
  border-left: 3px solid var(--border);
  background: var(--bg);
  color: var(--text-muted);
  font-size: 0.84rem;
  line-height: 1.45;
  text-align: left;
}

.delete-confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.delete-confirm-submit {
  padding: 10px 16px;
  border: 0;
  border-radius: var(--radius);
  background: var(--error);
  color: white;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.delete-confirm-submit:hover {
  background: #DC2626;
}

.delete-confirm-submit:focus-visible,
.delete-confirm-cancel:focus-visible {
  outline: 3px solid rgba(108, 99, 255, 0.3);
  outline-offset: 2px;
}

/* ══════════════════════════════════════════════════════════
   IMAGE BLOCK
══════════════════════════════════════════════════════════ */
.image-block {
  margin: 16px 0;
}

.image-block img {
  max-width: 100%;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.image-caption {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 0.9rem;
  font-style: italic;
  color: var(--text-muted);
  text-align: center;
}

.image-upload {
  padding: 40px;
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  text-align: center;
}

/* ══════════════════════════════════════════════════════════
   TABLE BLOCK
══════════════════════════════════════════════════════════ */
.table-block {
  margin: 16px 0;
  overflow-x: auto;
}

.table-block table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}

.table-block th {
  background: var(--primary);
  color: white;
  padding: 0;
}

.table-block th input {
  width: 100%;
  background: transparent;
  border: none;
  color: white;
  padding: 12px;
  font-weight: 600;
  text-align: left;
}

.table-block td {
  border: 1px solid var(--border);
  padding: 0;
}

.table-block td input {
  width: 100%;
  border: none;
  padding: 10px;
  font-size: 0.95rem;
}

.table-block th input:focus,
.table-block td input:focus {
  outline: 2px solid var(--primary);
  outline-offset: -2px;
}

.table-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.table-delete-btn {
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.table-delete-btn:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.table-row-actions {
  background: var(--bg) !important;
  border: 1px solid var(--border) !important;
  padding: 4px !important;
  text-align: center;
  width: 40px;
}

/* ══════════════════════════════════════════════════════════
   TOAST
══════════════════════════════════════════════════════════ */
.toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  padding: 14px 24px;
  background: var(--primary);
  color: white;
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  font-weight: 600;
  z-index: 1000;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ══════════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════════ */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .header-actions {
    flex-direction: column;
  }
  
  .search-input {
    min-width: 100%;
  }
  
  .kanban {
    grid-template-columns: 1fr;
  }
  
  .editor-topbar {
    flex-wrap: wrap;
    gap: 8px;
  }

  .save-status {
    order: 3;
    width: 100%;
    margin: 0;
    text-align: center;
  }

  .editor-content {
    padding: 18px 12px max(260px, 38vh) 42px;
  }
  
  .page-header {
    gap: 8px;
  }
  
  .title-input {
    font-size: 1.8rem;
    min-width: 0;
  }
  
  .block-toolbar {
    top: auto;
    position: relative;
  }

  .toolbar-slash-hint,
  .keyboard-hint {
    display: none;
  }

  .block-controls {
    right: calc(100% + 3px);
  }

  .color-picker span {
    display: none;
  }
}

@media print {
  .editor-topbar,
  .block-toolbar,
  .keyboard-hint,
  .block-controls,
  .table-actions,
  .table-delete-btn,
  .slash-menu,
  .delete-confirmation-backdrop {
    display: none !important;
  }

  body,
  .editor {
    background: white;
  }

  .editor-content {
    max-width: none;
    padding: 0;
  }

  .block,
  .block.block-active {
    padding-left: 0;
    border-left: 0;
    background: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;4DAE4D;AAC5D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sGAAsG;EACtG,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;4DAE4D;AAC5D;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;4DAE4D;AAC5D;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;4DAE4D;AAC5D;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;4DAE4D;AAC5D;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;4DAE4D;AAC5D;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;sEACoE;EACpE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;4DAE4D;AAC5D;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wEAAiL;AACnL;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;4DAE4D;AAC5D;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;4DAE4D;AAC5D;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;4DAE4D;AAC5D;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;4DAE4D;AAC5D;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;;;;;IAQE,wBAAwB;EAC1B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;AACF","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   VARIABLES\n══════════════════════════════════════════════════════════ */\n:root {\n  --primary: #6C63FF;\n  --primary-dark: #5548E0;\n  --bg: #FAFBFC;\n  --surface: #FFFFFF;\n  --border: #E1E4E8;\n  --text: #1A1D23;\n  --text-muted: #6A737D;\n  --text-light: #959DA5;\n  --success: #22C55E;\n  --warning: #F59E0B;\n  --error: #EF4444;\n  --radius: 8px;\n  --shadow: 0 1px 3px rgba(0,0,0,0.08);\n  --shadow-lg: 0 10px 40px rgba(0,0,0,0.12);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  background: var(--bg);\n  color: var(--text);\n  line-height: 1.6;\n}\n\n.app {\n  min-height: 100vh;\n}\n\n/* ══════════════════════════════════════════════════════════\n   LOADING & UNAUTHORIZED\n══════════════════════════════════════════════════════════ */\n.loading,\n.unauthorized {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  gap: 20px;\n  padding: 20px;\n  text-align: center;\n}\n\n.unauthorized h1 {\n  font-size: 2rem;\n  color: var(--text);\n}\n\n.unauthorized p {\n  color: var(--text-muted);\n}\n\n/* ══════════════════════════════════════════════════════════\n   BUTTONS\n══════════════════════════════════════════════════════════ */\n.btn-primary,\n.btn-ghost {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: white;\n}\n\n.btn-primary:hover {\n  background: var(--primary-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(108,99,255,0.3);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.btn-ghost:hover {\n  background: var(--bg);\n  border-color: var(--primary);\n}\n\n/* ══════════════════════════════════════════════════════════\n   DASHBOARD\n══════════════════════════════════════════════════════════ */\n.dashboard {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 40px 3%;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.dashboard-header h1 {\n  font-size: 2rem;\n  color: var(--text);\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.search-input {\n  padding: 10px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 14px;\n  min-width: 250px;\n  background: var(--surface);\n  transition: border 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n/* ══════════════════════════════════════════════════════════\n   KANBAN\n══════════════════════════════════════════════════════════ */\n.kanban {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.kanban-column {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  min-height: 400px;\n}\n\n.column-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--border);\n}\n\n.column-header h2 {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.count {\n  background: var(--bg);\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.column-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.empty-column {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--text-light);\n  font-size: 0.9rem;\n}\n\n/* ══════════════════════════════════════════════════════════\n   CARD\n══════════════════════════════════════════════════════════ */\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.card:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.card-icon {\n  font-size: 1.5rem;\n  line-height: 1;\n}\n\n.card h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.card-badge {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: inline-block;\n}\n\n.badge-warning {\n  background: #FEF3C7;\n  color: #92400E;\n}\n\n.card-meta {\n  color: var(--text-light);\n  font-size: 0.8rem;\n  margin-bottom: 12px;\n}\n\n.card-actions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n}\n\n.card-action-btn {\n  padding: 6px 12px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--surface);\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.card-action-btn:hover {\n  background: var(--bg);\n  border-color: var(--primary);\n}\n\n.card-action-btn.delete:hover {\n  background: #FEE2E2;\n  border-color: var(--error);\n  color: var(--error);\n}\n\n/* ══════════════════════════════════════════════════════════\n   EDITOR\n══════════════════════════════════════════════════════════ */\n.editor {\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n.editor-topbar {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 8px 3%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: var(--shadow);\n}\n\n.editor-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.save-status {\n  margin-left: auto;\n  margin-right: 16px;\n  color: var(--text-light);\n  font-size: 0.8rem;\n}\n\n.save-status-dirty {\n  color: var(--warning);\n}\n\n.color-picker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.color-picker input[type=\"color\"] {\n  width: 40px;\n  height: 32px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.editor-content {\n  max-width: 960px;\n  margin: 0 auto;\n  /* Reserva espacio bajo el último bloque para poder escribir con el cursor\n     en una zona cómoda de la pantalla, no pegado al borde inferior. */\n  padding: 22px 48px max(320px, 42vh);\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.icon-input {\n  font-size: 2.25rem;\n  width: 58px;\n  text-align: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.icon-input:focus {\n  outline: 2px solid var(--primary);\n  border-radius: var(--radius);\n}\n\n.title-input {\n  flex: 1;\n  font-size: 2.15rem;\n  font-weight: 700;\n  border: none;\n  background: transparent;\n  color: var(--text);\n  padding: 4px 0;\n}\n\n.title-input:focus {\n  outline: none;\n}\n\n.title-input::placeholder {\n  color: var(--text-light);\n}\n\n/* ══════════════════════════════════════════════════════════\n   BLOCK TOOLBAR\n══════════════════════════════════════════════════════════ */\n.block-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 10px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n  position: sticky;\n  top: 55px;\n  z-index: 90;\n  box-shadow: var(--shadow);\n}\n\n.toolbar-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-right: 8px;\n  white-space: nowrap;\n}\n\n.tool-btn {\n  min-width: 32px;\n  height: 30px;\n  padding: 4px 8px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--surface);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.toolbar-slash-hint {\n  margin-left: auto;\n  color: var(--text-light);\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n\nkbd {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 5px;\n  border: 1px solid var(--border);\n  border-bottom-width: 2px;\n  border-radius: 4px;\n  background: var(--surface);\n  color: var(--text-muted);\n  font-family: inherit;\n  font-size: 0.75rem;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.keyboard-hint {\n  margin: 0 4px 8px;\n  color: var(--text-light);\n  font-size: 0.78rem;\n}\n\n.tool-btn:hover {\n  background: var(--primary);\n  color: white;\n  border-color: var(--primary);\n}\n\n/* ══════════════════════════════════════════════════════════\n   BLOCKS\n══════════════════════════════════════════════════════════ */\n.blocks {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.block {\n  display: flex;\n  position: relative;\n  gap: 6px;\n  min-height: 30px;\n  padding: 2px 6px;\n  border-left: 2px solid transparent;\n  border-radius: 4px;\n  transition: all 0.2s;\n  cursor: text;\n}\n\n.block:hover {\n  background: rgba(108,99,255,0.02);\n  border-left-color: var(--primary);\n}\n\n.block.block-active {\n  background: rgba(108,99,255,0.05);\n  border-left-color: var(--primary);\n  border-left-width: 2px;\n}\n\n.block-controls {\n  display: flex;\n  position: absolute;\n  right: calc(100% + 5px);\n  top: 2px;\n  flex-direction: column;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.2s;\n  z-index: 5;\n}\n\n.block:hover .block-controls,\n.block:focus-within .block-controls {\n  opacity: 1;\n}\n\n.block-btn {\n  width: 24px;\n  height: 22px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--surface);\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-btn:hover {\n  background: var(--bg);\n  border-color: var(--primary);\n}\n\n.block-btn.delete:hover {\n  background: #FEE2E2;\n  border-color: var(--error);\n}\n\n.block-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.block-content {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n}\n\n/* ══════════════════════════════════════════════════════════\n   BLOCK INPUTS\n══════════════════════════════════════════════════════════ */\n.input-h1,\n.input-h2,\n.input-h3,\n.input-text,\n.input-callout,\n.input-bullet,\n.input-numbered,\n.input-todo {\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  color: var(--text);\n  padding: 2px 0;\n  resize: none;\n  overflow: hidden;\n  min-height: 1.45em;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.input-h1 {\n  font-size: 1.7rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.input-h2 {\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.input-h3 {\n  font-size: 1.12rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.input-text {\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.input-callout {\n  font-size: 1rem;\n  background: #F0F0FF;\n  padding: 8px 10px;\n  border-left: 4px solid var(--primary);\n  border-radius: 4px;\n}\n\n.input-bullet {\n  font-size: 1rem;\n  padding-left: 21px;\n  background: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\"><circle cx=\"4\" cy=\"4\" r=\"3\" fill=\"%236C63FF\"/></svg>') no-repeat 3px 0.62em;\n}\n\n.input-numbered {\n  flex: 1;\n  font-size: 1rem;\n  min-width: 0;\n}\n\n.numbered-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n}\n\n.numbered-marker {\n  min-width: 24px;\n  padding-top: 2px;\n  color: var(--primary-dark);\n  font-weight: 600;\n  line-height: 1.5;\n  text-align: right;\n}\n\n.input-h1:focus,\n.input-h2:focus,\n.input-h3:focus,\n.input-text:focus,\n.input-callout:focus,\n.input-bullet:focus,\n.input-numbered:focus,\n.input-todo:focus {\n  outline: none;\n}\n\n.input-h1::placeholder,\n.input-h2::placeholder,\n.input-h3::placeholder,\n.input-text::placeholder,\n.input-callout::placeholder,\n.input-bullet::placeholder,\n.input-numbered::placeholder,\n.input-todo::placeholder {\n  color: var(--text-light);\n}\n\n.todo-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.todo-block input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  margin-top: 4px;\n}\n\n.divider {\n  border: none;\n  border-top: 2px solid var(--border);\n  margin: 9px 0;\n}\n\n/* Menú de comandos con / */\n.slash-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 200;\n  width: min(340px, calc(100vw - 40px));\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 6px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  box-shadow: var(--shadow-lg);\n}\n\n.slash-menu-title {\n  padding: 5px 8px 7px;\n  color: var(--text-light);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.slash-command {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text);\n  cursor: pointer;\n  text-align: left;\n}\n\n.slash-command:hover,\n.slash-command-selected {\n  background: rgba(108, 99, 255, 0.09);\n}\n\n.slash-command-icon {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  place-items: center;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--surface);\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.slash-command strong,\n.slash-command small {\n  display: block;\n}\n\n.slash-command strong {\n  font-size: 0.88rem;\n}\n\n.slash-command small {\n  margin-top: 1px;\n  color: var(--text-muted);\n  font-size: 0.74rem;\n}\n\n.slash-empty {\n  padding: 14px 10px;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n/* Confirmación de eliminación de bloques */\n.delete-confirmation-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(26, 29, 35, 0.42);\n  backdrop-filter: blur(2px);\n}\n\n.delete-confirmation-dialog {\n  width: min(430px, 100%);\n  padding: 24px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--surface);\n  box-shadow: var(--shadow-lg);\n  text-align: center;\n}\n\n.delete-confirmation-icon {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  margin: 0 auto 12px;\n  place-items: center;\n  border-radius: 50%;\n  background: #FEE2E2;\n  color: var(--error);\n  font-size: 1.25rem;\n  font-weight: 800;\n}\n\n.delete-confirmation-dialog h2 {\n  margin-bottom: 8px;\n  font-size: 1.2rem;\n}\n\n.delete-confirmation-dialog p {\n  color: var(--text-muted);\n  font-size: 0.92rem;\n  line-height: 1.5;\n}\n\n.delete-confirmation-dialog blockquote {\n  max-height: 84px;\n  margin: 14px 0 0;\n  overflow: hidden;\n  padding: 10px 12px;\n  border-left: 3px solid var(--border);\n  background: var(--bg);\n  color: var(--text-muted);\n  font-size: 0.84rem;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.delete-confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.delete-confirm-submit {\n  padding: 10px 16px;\n  border: 0;\n  border-radius: var(--radius);\n  background: var(--error);\n  color: white;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.delete-confirm-submit:hover {\n  background: #DC2626;\n}\n\n.delete-confirm-submit:focus-visible,\n.delete-confirm-cancel:focus-visible {\n  outline: 3px solid rgba(108, 99, 255, 0.3);\n  outline-offset: 2px;\n}\n\n/* ══════════════════════════════════════════════════════════\n   IMAGE BLOCK\n══════════════════════════════════════════════════════════ */\n.image-block {\n  margin: 16px 0;\n}\n\n.image-block img {\n  max-width: 100%;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n}\n\n.image-caption {\n  width: 100%;\n  margin-top: 8px;\n  padding: 8px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-style: italic;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.image-upload {\n  padding: 40px;\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  text-align: center;\n}\n\n/* ══════════════════════════════════════════════════════════\n   TABLE BLOCK\n══════════════════════════════════════════════════════════ */\n.table-block {\n  margin: 16px 0;\n  overflow-x: auto;\n}\n\n.table-block table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.table-block th {\n  background: var(--primary);\n  color: white;\n  padding: 0;\n}\n\n.table-block th input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: white;\n  padding: 12px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.table-block td {\n  border: 1px solid var(--border);\n  padding: 0;\n}\n\n.table-block td input {\n  width: 100%;\n  border: none;\n  padding: 10px;\n  font-size: 0.95rem;\n}\n\n.table-block th input:focus,\n.table-block td input:focus {\n  outline: 2px solid var(--primary);\n  outline-offset: -2px;\n}\n\n.table-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.table-delete-btn {\n  background: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.table-delete-btn:hover {\n  background: #dc2626;\n  transform: scale(1.1);\n}\n\n.table-row-actions {\n  background: var(--bg) !important;\n  border: 1px solid var(--border) !important;\n  padding: 4px !important;\n  text-align: center;\n  width: 40px;\n}\n\n/* ══════════════════════════════════════════════════════════\n   TOAST\n══════════════════════════════════════════════════════════ */\n.toast {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  padding: 14px 24px;\n  background: var(--primary);\n  color: white;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n  font-weight: 600;\n  z-index: 1000;\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* ══════════════════════════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════════════════════════ */\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .header-actions {\n    flex-direction: column;\n  }\n  \n  .search-input {\n    min-width: 100%;\n  }\n  \n  .kanban {\n    grid-template-columns: 1fr;\n  }\n  \n  .editor-topbar {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .save-status {\n    order: 3;\n    width: 100%;\n    margin: 0;\n    text-align: center;\n  }\n\n  .editor-content {\n    padding: 18px 12px max(260px, 38vh) 42px;\n  }\n  \n  .page-header {\n    gap: 8px;\n  }\n  \n  .title-input {\n    font-size: 1.8rem;\n    min-width: 0;\n  }\n  \n  .block-toolbar {\n    top: auto;\n    position: relative;\n  }\n\n  .toolbar-slash-hint,\n  .keyboard-hint {\n    display: none;\n  }\n\n  .block-controls {\n    right: calc(100% + 3px);\n  }\n\n  .color-picker span {\n    display: none;\n  }\n}\n\n@media print {\n  .editor-topbar,\n  .block-toolbar,\n  .keyboard-hint,\n  .block-controls,\n  .table-actions,\n  .table-delete-btn,\n  .slash-menu,\n  .delete-confirmation-backdrop {\n    display: none !important;\n  }\n\n  body,\n  .editor {\n    background: white;\n  }\n\n  .editor-content {\n    max-width: none;\n    padding: 0;\n  }\n\n  .block,\n  .block.block-active {\n    padding-left: 0;\n    border-left: 0;\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
